import { put, take, takeLatest, call, select } from 'redux-saga/effects';

import processesService from 'services/processesService';

import { workStepsModal, open, save, types } from './actions';
import { MODES } from './constants';
import { getMode, getWorkStepId } from './reducer';

export default function* root() {
  yield takeLatest(types.OPEN_REQUEST, watchInitiate);
  yield takeLatest(types.SAVE_REQUEST, watchSaveWorkStep);
}

function* watchInitiate(action) {
  try {
    const { callBack } = action.payload;
    const mode = yield select(getMode);
    if (mode === MODES.EDIT) {
      // fetch current work step
      const workStepId = yield select(getWorkStepId);
      const workStep = yield call(processesService.workSteps.get, workStepId);

      yield put(workStepsModal.setWorkStep({ workStep }));
    }

    yield put(open.success());

    if (callBack) {
      const action = yield take(types.SAVE_SUCCESS);
      yield call(callBack, {
        workStep: action.payload.workStep,
      });
    }
  } catch (error) {
    yield put(open.error(error));
  }
}

function* watchSaveWorkStep(action) {
  try {
    const { name, updateExistingQuoteItems } = action.payload;

    const mode = yield select(getMode);
    let workStepResponse;
    if (mode === MODES.CREATE) {
      workStepResponse = yield call(processesService.workSteps.create, {
        name,
      });
    } else {
      const workStepId = yield select(getWorkStepId);
      workStepResponse = yield call(
        processesService.workSteps.update,
        workStepId,
        { name, updateExistingQuoteItems },
      );
    }

    yield put(save.success({ workStep: workStepResponse }));
  } catch (error) {
    yield put(save.error(error));
  }
}
